<div class="w-full" [dir]="isArabic() ? 'rtl' : 'ltr'">
  <div class="bgWhiteColor mb-5 overflow-hidden rounded-xl border border-gray-100 shadow-sm">
    <div class="flex flex-col gap-4 px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
      <div class="flex items-center gap-4">
        <app-gift-box-icon />
        <div class="flex items-center gap-3">
          <span class="labelColorText text-[14px] font-bold">{{ isArabic() ? "الكمية" : "Quantity" }}</span>
          <app-stepper
            [itemQuantity]="offerSelectedQuantity()"
            (increaseQty)="increaseOfferQty()"
            (decreaseQty)="decreaseOfferQty()"
            (qtyChange)="onOfferQtyChange($event)"></app-stepper>
        </div>
      </div>

      <div class="flex max-w-2xl flex-1 items-center justify-end gap-4">
        <app-shopping-cart-icon />
        <div class="flex flex-1 flex-col gap-1.5">
          <div class="text-[15px] font-bold text-gray-800">
            <span class="textGreenColor font-extrabold">{{ currentSelectedCount() }}</span>
            /{{ totalRequiredCount() }}
            <span class="textHelpercolorone mx-1 text-[14px] font-medium">{{ isArabic() ? "محدد" : "Selected" }}</span>
          </div>
          <div class="bgHelpercolortwo h-3.5 w-full overflow-hidden rounded-full">
            <div
              class="bgGreenColor h-full rounded-full transition-all duration-300"
              [style.width.%]="progressPercentage()"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
    <div class="lg:col-span-2">
      <div class="borderhelpercolortwo bgWhiteColor mb-4 flex items-center gap-3 rounded-xl border px-4 py-3 shadow-sm">
        <app-search-icon />
        <input
          type="text"
          [placeholder]="isArabic() ? 'ابحث عن الأصناف....' : 'Search for products....'"
          (input)="onSearchInput($event)"
          class="flex-1 bg-transparent text-[14px] font-medium outline-none placeholder:text-gray-400" />
      </div>

      <div class="borderhelpercolortwo bgWhiteColor overflow-hidden rounded-xl border shadow-sm">
        @if (loadingProducts()) {
          <app-loading />
        } @else {
          @for (product of availableProducts(); track product.id) {
            <div
              class="flex items-center justify-between border-b border-gray-100 px-5 py-4 last:border-0 hover:bg-gray-50/50">
              <div class="flex min-w-0 flex-1 items-center gap-4">
                <div
                  class="borderhelpercolortwo bgWhiteColor flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-xl border p-1 shadow-sm">
                  @if ($any(product).profileImageFid && imagePreviews()[$any(product).profileImageFid]) {
                    <img
                      [src]="imagePreviews()[$any(product).profileImageFid]!"
                      class="max-h-full max-w-full object-contain" />
                  } @else {
                    <app-image-placeholder-icon />
                  }
                </div>

                <div class="min-w-0 flex-1">
                  <h4 class="labelColorText text-[15px] font-bold">
                    {{ isArabic() ? product.titleAr : product.titleEn }}
                  </h4>

                  <div class="mt-2.5 flex flex-col gap-2">
                    <div class="flex items-center">
                      <div class="flex min-w-[140px] items-center gap-1.5">
                        @if (product.businessPrice) {
                          <app-business-price-icon />
                          <span class="labelColorText text-[13px] font-bold">
                            {{ product.businessPrice }} {{ isArabic() ? "ج.م" : "EGP" }}
                          </span>
                          @if (product.businessPriceDiscountPercentage) {
                            <span class="text-[11px] font-semibold text-green-600">
                              ({{ isArabic() ? "خصم" : "Discount" }} {{ product.businessPriceDiscountPercentage }}%)
                            </span>
                          }
                        }
                      </div>

                      <div class="flex w-16 justify-center">
                        <span class="text-gray-300">|</span>
                      </div>

                      <div class="flex items-center gap-1.5">
                        @if (product.customerPrice) {
                          <app-customer-price-icon />
                          <span class="textTabsColor text-[13px] font-bold">
                            {{ product.customerPrice }} {{ isArabic() ? "ج.م" : "EGP" }}
                          </span>
                        }
                      </div>
                    </div>

                    @if (product.mfgDate || product.expDate || product.batchNumber) {
                      <div class="flex items-center text-sm font-medium text-gray-900">
                        <div class="flex min-w-[140px] items-center gap-1.5">
                          @if (product.mfgDate && product.expDate) {
                            <app-mfg-exp-dates-icon />
                            <span class="truncate">
                              {{ product.mfgDate | date: "yy" }}-{{ product.mfgDate | date: "MM" }}-{{
                                product.expDate | date: "yy"
                              }}
                            </span>
                          } @else if (product.expDate) {
                            <app-mfg-exp-dates-icon />
                            <span class="truncate">{{ product.expDate | date: "MM/yy" }}</span>
                          }
                        </div>

                        <div class="flex w-16 justify-center">
                          <span class="text-gray-300">|</span>
                        </div>

                        <div class="flex min-w-0 items-center gap-1.5">
                          @if (product.batchNumber) {
                            <app-batch-number-icon />
                            <span class="min-w-0 truncate" [title]="product.batchNumber">
                              {{ product.batchNumber }}
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div class="ms-4 flex flex-shrink-0 items-center justify-end">
                <button
                  (click)="addProductToOffer(product)"
                  [disabled]="isLimitReached()"
                  class="bgTabsColor hover:bgHoverPrimaryColor min-w-[80px] cursor-pointer rounded-lg px-6 py-2 text-[14px] font-bold text-white shadow-sm transition-all active:scale-95 disabled:cursor-not-allowed disabled:opacity-40">
                  {{ isArabic() ? "إضافة" : "Add" }}
                </button>
              </div>
            </div>
          }
        }
      </div>

      @if (showMaxLimitError()) {
        <p class="mt-2.5 text-[13px] font-bold text-red-500">
          {{
            isArabic()
              ? "لا يمكنك اختيار عدد منتجات أكثر من الحد المسموح به."
              : "You cannot select more than the allowed number of products for this offer."
          }}
        </p>
      }
    </div>

    <div class="self-start lg:sticky lg:top-6">
      <div class="borderhelpercolortwo rounded-xl border bg-gray-50/50 p-5 shadow-sm">
        <h3 class="textHelpercolorone mb-4 text-center text-[14px] font-bold tracking-wider uppercase">
          {{ isArabic() ? "الأصناف المحددة" : "Selected Products" }}
        </h3>

        <div class="mb-4 max-h-[320px] space-y-3 overflow-y-auto pr-1">
          @if (selectedItems().length === 0) {
            <p
              class="borderhelpercolortwo bgWhiteColor rounded-xl border py-8 text-center text-[13px] font-medium text-gray-400">
              {{ isArabic() ? "لم يتم تحديد أي صنف" : "No products selected yet" }}
            </p>
          }
          @for (item of selectedItems(); track item.id) {
            <div
              class="borderhelpercolortwo bgWhiteColor flex items-center justify-between gap-3 rounded-xl border p-3 shadow-sm">
              <div class="min-w-0 flex-1">
                <h5 class="labelColorText truncate text-[13px] font-bold">
                  {{ isArabic() ? item.titleAr : item.titleEn }}
                </h5>
                <p class="textHelpercolorone mt-0.5 text-[12px] font-bold">
                  {{ item.businessPrice }} {{ isArabic() ? "ج.م" : "EGP" }}
                </p>
                <div class="mt-2">
                  <app-stepper
                    [itemQuantity]="item.selectedQty"
                    (increaseQty)="updateProductQtyInsideOffer(item.id, 1)"
                    (decreaseQty)="updateProductQtyInsideOffer(item.id, -1)"></app-stepper>
                </div>
              </div>
              <button
                (click)="removeProductFromOffer(item.id)"
                class="borderhelpercolortwo bgWhiteColor flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg border text-gray-400 shadow-sm transition-all hover:border-red-200 hover:text-red-500">
                <app-trash-icon />
              </button>
            </div>
          }
        </div>

        <div class="space-y-3 border-t border-gray-200 pt-4">
          <div class="flex items-center justify-between px-1 text-[13px]">
            <span class="textHelpercolorone font-medium">{{ isArabic() ? "الإجمالي العادي" : "Regular Total" }}</span>
            <span class="font-bold text-gray-400 line-through">
              {{ regularTotal() | number: "1.2-2" }} {{ isArabic() ? "ج.م" : "EGP" }}
            </span>
          </div>
          <div class="flex flex-col gap-1 px-1 text-[14px]">
            <span class="textGreenColor font-bold">
              {{ isArabic() ? "إجمالي السعر بعد العرض للصيدلية" : "Total Pharmacy Price After Offer" }}
            </span>
            <span class="textGreenColor text-[18px] font-black">
              {{ offerTotal() | number: "1.2-2" }} {{ isArabic() ? "ج.م" : "EGP" }}
            </span>
          </div>

          <div class="mt-4 grid grid-cols-2 gap-3 pt-1">
            <button
              (click)="cancel.emit()"
              class="borderhelpercolortwo bgWhiteColor rounded-xl border py-2.5 text-[13px] font-bold text-gray-600 shadow-sm transition-all hover:bg-gray-50 active:scale-95">
              {{ isArabic() ? "إلغاء" : "Cancel" }}
            </button>
            <button
              (click)="confirmOfferSelection()"
              [disabled]="currentSelectedCount() !== totalRequiredCount() || isAdding()"
              class="bgGreenColor hover:bgHoverGreenColor cursor-pointer rounded-xl py-2.5 text-[13px] font-bold text-white shadow-sm transition-all active:scale-95 disabled:cursor-not-allowed disabled:opacity-40">
              @if (isAdding()) {
                {{ isArabic() ? "جاري الإضافة..." : "Adding..." }}
              } @else {
                {{ isArabic() ? "تأكيد" : "Confirm" }}
              }
            </button>
          </div>
          @if (addError()) {
            <p class="mt-2 text-center text-[12px] font-bold text-red-500">{{ addError() }}</p>
          }
        </div>
      </div>
    </div>
  </div>
</div>
